import React from "react";
import classes from "./spareHighlight.module.css";

export const SpareHighlights = ({ highlights }) => {
  console.log(highlights?highlights : "No highlights available");
 
  return (
    <div className={classes.container}>
      <div className={classes.container__info}>
        <h1 className={classes.container__info__title}>Highlights</h1>
        <div className={classes.box}>
          {highlights.map((highlight, index) => (
            <div key={index} className={classes.box__desc}>
              <div className={classes.box__desc__bullet} />
              <h2 className={classes.box__desc__text}>{highlight}</h2>
            </div>
          ))}
        </div>
      </div>
      <hr className={classes.box__divider} />
    </div>
  );
};
